<template>
  <b-modal id="history-email" size="xl" :title="$t('dashboard.scheduler.history')" centered>
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :hasCheckbox="false"
      :searchable="true"
      :isSelectableField="false"
      :withCard="false"
      :stickyHeader="true"
      trackBy="reportSchedulerId"
      class="mc-table--4 mc-table--detail"
    >
      <template #cell(sentOn)="data">
        <span>{{ momentDateLongMonth(data.item.sentOn) }}</span>
      </template>
      <template #cell(recipients)="data">
        <div class="text-wrap">
          {{ data.item.recipients }}
        </div>
      </template>
      <template #cell(status)="data">
        <McBadge
          :text="$t('dashboard.scheduler.delivered')"
          variant="outlineSuccess"
          type="button"
          v-if="data.item.status === 'S'"
        />
        <div v-else>
          <McBadge
            :text="$t('dashboard.scheduler.notDelivered')"
            variant="outlineDanger"
            type="button"
            class="d-inline-block"
          />
          <i
            class="mc-fa icon-fill_refresh font-size-20 ms-3 align-middle"
            role="button"
            @click="handleSentNow(data.item.reportSchedulerId)"
            v-b-tooltip.hover
            :title="$t('dashboard.scheduler.resend')"
          ></i>
        </div>
      </template>
    </McGrapqlTable>
    <template #modal-footer>
      <div>
        <b-button variant="outline-primary" @click="cancel()">{{
          $t('global.action.close')
        }}</b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import appConfig from '@/app.config'
import McGrapqlTable from '@/components/McGrapqlTable'
import McBadge from '@/components/McBadge'
import { GET_REPORT_SCHEDULER_HISTORY } from '@/services/api/report/report'
import { SEND_REPORT_HTML } from '@/services/api/dashboard/scheduler'
import { Helper } from '@/mixin/helper'
export default {
  page: {
    title: 'Kirim Rangkuman',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    McGrapqlTable,
    McBadge,
  },
  mixins: [Helper],
  data() {
    return {
      reportSchedulerId: 0,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'scheduleName',
          label: this.$t('report.title.scheduleName'),
          isSortable: true,
        },
        {
          key: 'recipients',
          label: this.$t('report.object.reportRecipient'),
          isSortable: true,
        },
        {
          key: 'sentOn',
          label: this.$t('report.object.deliveryDate'),
          isSortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          isSortable: true,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_REPORT_SCHEDULER_HISTORY,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                reportName: 'Email Digest',
              },
            },
          })
          return res.data.reportSchedulerHistory.reportSchedulerHistory
        },
      }
    },
  },
  methods: {
    cancel() {
      this.$bvModal.hide('history-email')
    },
    async handleSentNow(id) {
      const res = await this.$apollo.mutate({
        mutation: SEND_REPORT_HTML,
        variables: {
          input: {
            reportSchedulerId: Number(id),
          },
        },
      })
      if (res.data.sendReportHtml.isSuccessful) {
        this.$mcToast.success(this.$t('dashboard.scheduler.dashboardSent'))
      } else {
        this.$mcToast.error(res.data.sendReportHtml.message)
      }
    },
  },
}
</script>
